import { render } from "./HeaderHjpTable.vue?vue&type=template&id=2964ce54&ts=true"
import script from "./HeaderHjpTable.vue?vue&type=script&lang=ts"
export * from "./HeaderHjpTable.vue?vue&type=script&lang=ts"

import "./HeaderHjpTable.vue?vue&type=style&index=0&id=2964ce54&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__